export default __webpack_public_path__ + "static/media/655.23fe3092.jpg";